<template>
  <prona-wizard-step v-if="wizardData" class="wizard-step-nims-topic" :custom-proceed-function="customProceed" :errors="validationError">
    <p-request-alert v-model="error"></p-request-alert>
    <p-progress-linear v-if="isLoading" class="my-5" indeterminate></p-progress-linear>
    <div v-else>
      <div class="nims-topic-selection">
        <p-row>
          <p-col>
            <p>{{ $t('pronatura.widget.nimswizard.offer_selection.natureOffer') }}</p>
            <div :class="classList">
              <p-radio-field
                v-for="topic in topics.items"
                :key="topic.id"
                v-model="wizardData.natureOffer"
                :label="topic.caption"
                :true-value="topic.id"
                name="natureOffer"
                required
                @change="validate()"
              ></p-radio-field>
            </div>
          </p-col>
        </p-row>
      </div>
      <div v-if="wizardData.isNatureOfferAdvice" class="nims-GardenAdvice">
        <p-row>
          <p-col>
            <p>{{ $t('pronatura.widget.nimswizard.offer_selection.gardenAdviceListLabel') }}</p>
            <div :class="classgardenAdviceList">
              <p-checkbox-group
                key="gardenAdviceList"
                v-model="wizardData.gardenAdvice.gardenAdviceList"
                :items="nimSGardenAdvices.items"
                required
                @input="onclassGardenAdviceListSelect(wizardData.gardenAdvice.gardenAdviceList)"
              ></p-checkbox-group>
              <div v-if="wizardData.gardenAdvice.hasOtherUpgrades">
                <p-text-field v-model="wizardData.gardenAdvice.otherUpgrade" required :label="$t('pronatura.widget.nimswizard.offer_selection.others')"></p-text-field>
              </div>
            </div>
          </p-col>
        </p-row>
      </div>
      <div v-if="wizardData.isNatureOfferCertification" class="nims-GardenCertification">
        <p-row>
          <p-col>
            <p>{{ $t('pronatura.widget.nimswizard.offer_selection.minimumRequirementsListLabel') }}</p>
            <div :class="classminimumRequirementsList">
              <p-checkbox-group
                key="minimumRequirementsList"
                v-model="wizardData.gardenCertification.minimumRequirementsList"
                :items="nimSCertifications.items"
                required
              ></p-checkbox-group>
            </div>
            <p-row>
              <p-col>
                <p-alert :value="true" type="info">
                  {{ $t('pronatura.widget.nimswizard.offer_selection.minimumRequirementsListLabel.errorMessage') }}
                </p-alert>
              </p-col>
            </p-row>
            <p-row>
              <p-checkbox v-model="wizardData.gardenCertification.wasAlreadyCertificated" :label="$t('pronatura.widget.nimswizard.offer_selection.wasAlreadyCertificated')"></p-checkbox>
            </p-row>
            <p-row>
              <p-col ml10>
                <div v-if="wizardData.gardenCertification.wasAlreadyCertificated">
                  <p>{{ $t('pronatura.widget.nimswizard.offer_selection.certificateLabel') }}</p>
                  <div :class="classCertificate">
                    <p-radio-field
                      v-for="nimSCertificat in nimSCertificats.items"
                      :key="nimSCertificat.id"
                      v-model="wizardData.gardenCertification.certificate"
                      :label="nimSCertificat.caption"
                      :true-value="nimSCertificat.id"
                      name="certificate"
                      required
                      @change="onclassCertificate(nimSCertificat.id)"
                    ></p-radio-field>
                  </div>
                </div>
              </p-col>
            </p-row>
          </p-col>
        </p-row>
      </div>
      <div class="nims-remark">
        <p-row>
          <p-col>
            <p-textarea v-model="wizardData.remarks" :label="$t('pronatura.widget.nimswizard.offer_selection.remarks')"></p-textarea>
          </p-col>
        </p-row>
      </div>
    </div>
  </prona-wizard-step>
</template>

<script lang="ts">
  import NimSRegistrationRequestViewModel from '@/src/services/v1/viewModel/resource/NimSRegistrationRequestViewModel';
  import Vue, { PropType } from 'vue';
  import GuidLookupResourceListResultViewModel from '@/src/services/v1/viewModel/resource/GuidLookupResourceListResultViewModel';
  import nimsTopicSchema from './1.nims-topic-schema';

  export default Vue.extend({

    name: 'WizardStepNimSTopic',
    props: {
      value: { type: Object, default: undefined },
      proceedFunction: { type: Function as PropType<(()=>void)>, default: () => {} },
    },
    data: () => ({
      isLoading: true,
      error: undefined as any,
      topics: {} as GuidLookupResourceListResultViewModel,
      nimSGardenAdvices: {} as GuidLookupResourceListResultViewModel,
      nimSCertifications: {} as GuidLookupResourceListResultViewModel,
      nimSCertificats: {} as GuidLookupResourceListResultViewModel,
      validationErrorTopic: undefined as string | undefined,
      validationErrorGardenAdvice: undefined as string | undefined,
      validationErrorMinimumRequirements: undefined as string | undefined,
      validationErrorCertificate: undefined as string | undefined,
    }),
    computed: {
      validationError(): string {
        if (this.isLoading) return '';
        if (this.wizardData.isNatureOfferAdvice) {
          return this.validationErrorGardenAdvice!;
        }
        if (this.wizardData.isNatureOfferCertification) {
          const selectedList:string[] = this.wizardData.gardenCertification.minimumRequirementsList ?? [];
          const requiredItems:string[] = (this.nimSCertifications.items.map((x) => x.id!));
          if (requiredItems.length > 0 && requiredItems.length !== selectedList.length && !requiredItems.every((v) => selectedList.includes(v))) {
            return this.validationErrorMinimumRequirements!;
          }
          return this.validationErrorCertificate!;
        }
        return this.validationErrorTopic ?? '';
      },
      classList(): Record<string, boolean> {
        return {
          'input-error': this._.isSet(this.validationErrorTopic),
        };
      },
      classgardenAdviceList(): Record<string, boolean> {
        return {
          'input-error': this._.isSet(this.validationErrorGardenAdvice),
        };
      },
      classminimumRequirementsList(): Record<string, boolean> {
        return {
          'input-error': this._.isSet(this.validationErrorMinimumRequirements),
        };
      },
      classCertificate(): Record<string, boolean> {
        return {
          'input-error': this._.isSet(this.validationErrorCertificate),
        };
      },
      wizardData: {
        get(): NimSRegistrationRequestViewModel {
          return this.value ?? {};
        },
        set(value: NimSRegistrationRequestViewModel) {
          this.$emit('input', value);
        },
      },
    },
    watch: {
      'wizardData.natureOffer': {
        handler() {
          if (this._.isSet(this.wizardData.natureOffer)) {
            this.validationErrorTopic = undefined;
          }
        },
      },
      'wizardData.gardenAdvice.gardenAdviceList': {
        handler() {
          if (this._.isSet(this.wizardData.gardenAdvice.gardenAdviceList)) {
            this.validationErrorGardenAdvice = undefined;
          }
        },
      },
      'wizardData.gardenCertification.minimumRequirementsList': {
        handler() {
          if (this._.isSet(this.wizardData.gardenCertification.minimumRequirementsList)) {
            this.validationErrorMinimumRequirements = undefined;
          }
        },
      },
      'wizardData.gardenCertification.certificate': {
        handler() {
          if (this._.isSet(this.wizardData.gardenCertification.certificate)) {
            this.validationErrorCertificate = undefined;
          }
        },
      },
    },
    async beforeMount() {
      this.isLoading = true;
      try {
        this.topics = await this.$service.api.widgetNimSTopics.getNimSTopics();
        this.nimSGardenAdvices = await this.$service.api.widgetNimSGardenAdvices.getNimSGardenAdvices();
        this.nimSCertifications = await this.$service.api.widgetNimSGardenCertifications.getNimSGardenCertifications();
        this.nimSCertificats = await this.$service.api.widgetNimSCertificats.getNimSCertificates();
      } catch (error: any) {
        this.error = error;
        this.$log.error(error);
      }
      this.isLoading = false;
    },
    methods: {
      validate(): boolean {
        if (!this._.isSet(this.wizardData.natureOffer)) {
          this.validationErrorTopic = this.$t('pronatura.widget.nimswizard.offer_selection.natureOffer.errorMessage');
          return false;
        }
        return this.wizardData.validateWithSchema(nimsTopicSchema);
      },
      validateMinimumRequirementsList(): boolean {
        const selectedList:string[] = this.wizardData.gardenCertification.minimumRequirementsList ?? [];
        const requiredItems:string[] = (this.nimSCertifications.items.map((x) => x.id!));
        if (requiredItems.length > 0 && requiredItems.length !== selectedList.length && !requiredItems.every((v) => selectedList.includes(v))) {
          this.validationErrorMinimumRequirements = this.$t('pronatura.widget.nimswizard.offer_selection.minimumRequirementsListLabel.errorMessage');
          return false;
        }
        return true;
      },
      validateGardenAdviceList(): boolean {
        const selectedList = this.wizardData.gardenAdvice.gardenAdviceList ?? [];

        if (!(selectedList.length > 0) && (this.wizardData.gardenAdvice.hasOtherUpgrades !== true)) {
          this.validationErrorGardenAdvice = this.$t('pronatura.widget.nimswizard.offer_selection.gardenAdviceListLabel.errorMessage');
          return false;
        }
        return true;
      },
      validateCertificate(): boolean {
        if (!this._.isSet(this.wizardData.gardenCertification.certificate) || this.wizardData.gardenCertification.certificate === null) {
          this.validationErrorCertificate = this.$t('pronatura.widget.nimswizard.offer_selection.certificate.errorMessage');
          return false;
        }
        return true;
      },

      customProceed() {
        this.validationErrorTopic = undefined;
        this.validationErrorGardenAdvice = undefined;
        this.validationErrorMinimumRequirements = undefined;
        this.validationErrorCertificate = undefined;

        if (this.validate()) {
          if (this.wizardData.isNatureOfferAdvice) {
            if (this.validateGardenAdviceList()) {
              this.proceedFunction!();
            }
          } else if (this.wizardData.isNatureOfferCertification) {
            if (this.validateMinimumRequirementsList()) {
              if (this.wizardData.gardenCertification.wasAlreadyCertificated === true) {
                if (this.validateCertificate()) {
                  this.proceedFunction!();
                }
              } else {
                this.proceedFunction!();
              }
            }
          }
        }
      },
      onclassGardenAdviceListSelect(ids: string[] | null | undefined) {
        this.wizardData.gardenAdvice.hasOtherUpgrades = ids?.some((x) => x.toUpperCase() === Vue.$config.values['natureoffer-certification-other-upgrades'].toUpperCase());
        this.$set(this.wizardData.gardenAdvice, 'hasOtherUpgrades', this.wizardData.gardenAdvice.hasOtherUpgrades);
      },
      onclassCertificate(id: string | undefined) {
        this.wizardData.gardenCertification.certificate = id;
        this.$set(this.wizardData.gardenCertification, 'certificate', id);
      },
    },
  });
</script>
